import React from "react";
import { Alert } from "@mui/material";
import { useAdminDataGuard } from "../hooks/useAdminDataGuard";
import PromoCodeConsole from "../components/partner/PromoCodeConsole";

const AdminPartnerPage = () => {
  const canAccessAdminData = useAdminDataGuard();

  if (!canAccessAdminData) {
    return <Alert severity='error'>Admin token validation failed.</Alert>;
  }

  return <PromoCodeConsole />;
};

export default AdminPartnerPage;
